import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {RelatedBusinessProcessConfig} from '../../Models/relatedBusinessProcessConfig';

@Injectable({
  providedIn: 'root'
})
export class DriverService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getDriversForUpdate() {
    return this.http.get<any[]>('/api/driver/getForUpdate');
  }

  getChangelog(driverName, driverVersion ) {
    return this.http.get<any>(`/api/driver/getChangelog/${driverName}/${driverVersion}`);
  }

  install(driver) {
    return this.http.post<any>('/api/driver/install', driver);
  }
}
